var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.3,
    height: 39.521,
    viewBox: "0 0 42.3 39.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5724",
    "data-name": "Group 5724",
    transform: "translate(0 0.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M2479.818,210.757c-.544.537-1.094,1.071-1.635,1.613-.443.441-.877.891-1.32,1.343a25.7,25.7,0,0,0-36.374-.044l-2.972-2.972c.414-.388.825-.822,1.287-1.2,1.015-.824,2.023-1.663,3.094-2.41a27.866,27.866,0,0,1,6.132-3.211,29.815,29.815,0,0,1,11.251-1.943,29.542,29.542,0,0,1,13.742,3.677,30.009,30.009,0,0,1,5.947,4.3c.284.263.565.528.846.792Z",
    transform: "translate(-2437.518 -196.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M2471.255,213l-2.973,2.953a17.281,17.281,0,0,0-24.457,0L2440.858,213A21.393,21.393,0,0,1,2471.255,213Z",
    transform: "translate(-2434.917 -193.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M2444.222,215.232a12.983,12.983,0,0,1,18.443.02l-2.983,2.955a8.841,8.841,0,0,0-12.5,0Z",
    transform: "translate(-2432.297 -189.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M2452,244.558a10.819,10.819,0,0,1-1.09-.271,4.8,4.8,0,0,1-3.292-3.767,4.731,4.731,0,0,1,1.908-4.964c1.223-.918,11.182-19.829,16.067-29.192a.552.552,0,0,1,1.018.41c-3.042,10.218-9.18,31.057-9.108,32.488a4.932,4.932,0,0,1-4.01,5.2c-.152.034-.308.068-.463.1Z",
    transform: "translate(-2432.456 -206.063)",
    fill: "#fff",
    stroke: "#7b7b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/iot.f7542ab3180512a39b3fed8f4d998977.svg";
export { ForwardRef as ReactComponent };